"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountService = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
const http_1 = require("@angular/common/http");
const _ = require("underscore");
const i0 = require("@angular/core");
const i1 = require("@angular/common/http");
class AccountService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.accountDetailsStatus = false;
        this.ringTimeUrl = '/rest-api/account/v1/subscriptions/ringTime';
        this.callForwardingUrl = '/rest-api/account/v1/callForwarding';
        this.emailUrl = '/rest-api/account/v1/email-verification/status/';
        this.accounturl = '/rest-api/account/v1/details';
        this.updateAccountUrl = '/rest-api/account/sub/v1/details';
        this.accountInfoLiteUrl = '/rest-api/account/v1/details/lite';
        this.getSessionIdUrl = '/rest-api/profile/v1/sessionId';
        this.logOutUrl = '/rest-api/profile/v1/signOut';
        this.linkToFiber = '/rest-api/account/link/v1/fiberAccount';
        this.linkToFiberAcc = '/rest-api/account/link/v1/fiber/account';
        this.linkWirelessWithSSN = '/rest-api/account/link/v1/linkWithSSN';
        this.linkWirelessWithMDN = '/rest-api/account/link/v1/linkWirelessWithMDN';
        this.linkToWireless = '/rest-api/account/link/v1/nonBillingToBilling';
        this.manageFiberAndWireless = '/rest-api/account/link/v1/manageWireless';
        this.linkFiberToWireless = '/rest-api/account/link/v1/wirelessAccount';
        this.linkToWirelessPin = '/rest-api/account/link/v1/updateFiberAccount';
        this.errorMsgUrl = '/resources/json/mma/feerrormsg.json';
        this.linkCSBS = '/rest-api/account/link/v1/csbsAccount';
        this.primarylookUpUrl = '/rest-api/profile/v1/lookupPrimary';
        this.fiberAccountUrl = '/rest-api/fiber/account/services/v1/details';
        this.fiberAccountInclInactiveAccountsUrl = this.fiberAccountUrl + '?includeInactiveAccounts=true';
        this.fiberAccountLiteUrl = '/rest-api/fiber/account/services/v1/details/lite';
        this.fiberAccountLiteInclInactiveAccountsUrl = this.fiberAccountLiteUrl + '?includeInactiveAccounts=true';
        this.fiberAccountLoadedUrl = '/rest-api/fiber/account/services/v1/details/loaded';
        this.fiberAccountSubscriptionsURL = '/rest-api/fiber/account/services/v2/subscriptions';
        this.fiberAccountExpressPayUrl = '/rest-api/fiber/account/services/v1/details/expressPay';
        this.deviceListUrl = '/rest-api/account/v1/myDevices';
        this.installmentDetailUrl = '/rest-api/account/sub/installment/v1/details/';
        this.profileStateUrl = '/global/profileController.jsp?action=getProfileState';
        this.fundsUrl = '/rest-api/account/sub/v1/funds/';
        this.savedCard = '/rest-api/account/payment/creditcard/v1/saved-details/3';
        this.payByCC = '/rest-api/account/payment/creditcard/v1/save';
        this.submitPayment = '/rest-api/account/payment/creditcard/v1/submit';
        this.submitPaymentGiftCard = '/rest-api/account/payment/giftcard/v1/submit';
        this.accountDetailUrl = '/rest-api/profile/v1/get/personalInfo';
        this.accountDetailUrlHS = '/rest-api/fiber/account/profile/v1/get/personalInfo';
        this.removeGiftCardUrl = '/rest-api/account/payment/giftcard/v1/remove/';
        this.registerServiceUrl = '/rest-api/account/bill/v1/billingreport';
        this.viewBillreportUrl = '/rest-api/account/bill/v1/business/billingreport';
        this.subDetailsUrl = '/rest-api/account/subscription/v1/details/';
        this.loginDetailsUrl = '/global/profileController.jsp?action=getProfileState';
        this.paymentAuthStatusUrl = '/rest-api/profile/v1/payment-auth-status/';
        // Profile services
        this.getProfileDetailsUrl = '/rest-api/profile/v1/getProfile/';
        this.createProfileUrl = '/rest-api/profile/v1/createProfile';
        this.subscribeProfileUrl = '/rest-api/profile/v1/subscriberProfile';
        this.updatePermissionUrl = '/rest-api/profile/v1/updatePermission';
        this.savedPermissionUrl = '/rest-api/profile/v1/savedPermission/';
        this.resetPasswordUrl = '/rest-api/profile/v1/resetPassword';
        this.getDepartmentListUrl = '/rest-api/profile/business/getDepartment/departmentId';
        this.allMMAProfilesUrl = '/rest-api/profile/v1/get-profiles/';
        this.accountInfoLoadSuccessBS = new rxjs_1.BehaviorSubject([]);
        this.emitAccountInfoLoadSuccess$ = this.accountInfoLoadSuccessBS.asObservable();
        // WSDL status check for search auto-complete
        this.wsdlLoadStatusBS = new rxjs_1.BehaviorSubject([]);
        this.emitWSDLLoadStatus$ = this.wsdlLoadStatusBS.asObservable();
        // Department services
        this.departmentDetailsUrl = '/rest-api/account/v1/business/department/details';
        this.addDivisionUrl = '/rest-api/account/v1/business/department/details';
        this.addDepartmentUrl = '/rest-api/account/v1/business/department/details';
        this.accountDetailsWsdlStatusURL = '/rest-api/account/v1/getAccountWSDLCompletionStatus';
        this.updateProfileUrl = '/rest-api/profile/v1/updateProfile';
        this.savedBankDetailUrl = '/rest-api/account/payment/bank/v1/savedDetails/';
        // Primary Payments Services
        this.addCallForwardingUrl = '/rest-api/profile/v1/addRemoveCallForwarding';
        this.saveNewCardUrl = '/rest-api/account/profilePayments/v1/saveCCDetails';
        this.deleteSavedCardCardUrl = '/rest-api/account/profilePayments/v1/deleteCCDetails/';
        this.editSavedCardUrl = '/rest-api/account/profilePayments/v1/editCCDetails/';
        this.saveBankUrl = '/rest-api/account/profilePayments/v1/saveBankDetails/';
        this.deleteSavedBankUrl = '/rest-api/account/profilePayments/v1/deleteBankDetails/';
        this.savedCCDetailsUrl = '/rest-api/account/profilePayments/v1/savedCCDetails/';
        this.savedPrimaryBankUrl = '/rest-api/account/profilePayments/v1/savedBankDetails/';
        // Home services Primary Payments Services
        this.saveNewCardHSUrl = '/rest-api/account/profilePayments/v1/homeservice/saveCCDetails';
        this.deleteSavedCardCardHSUrl = '/rest-api/account/profilePayments/v1/homeservice/deleteCCDetails/';
        this.editSavedCardHSUrl = '/rest-api/account/profilePayments/v1/homeservice/editCCDetails/';
        this.saveBankHSUrl = '/rest-api/account/profilePayments/v1/homeservice/saveBankDetails/';
        this.deleteSavedBankHSUrl = '/rest-api/account/profilePayments/v1/homeservice/deleteBankDetails/';
        this.savedCCDetailsHSUrl = '/rest-api/account/profilePayments/v1/homeservice/savedCCDetails/';
        this.savedPrimaryBankHSUrl = '/rest-api/account/profilePayments/v1/homeservice/savedBankDetails/';
        this.verifyEmailLink = '/rest-api/account/v1/send/emailLink';
        this.convertBasketStatusURL = '/rest-api/shopping-basket/v1/cart/convert';
        this.isApplyForWirelessBundleDiscountUrl = '/rest-api/profile/v1/applyForWirelessBundleDiscount/';
        this.pulseOfferUrl = '/rest-api/account/getPulseOffer';
        // Payment Plan Services
        this.cppBalanceUrl = '/rest-api/payment-plan/v1/plan?isWireless=';
        this.saveHSCPPDetailsUrl = '/rest-api/fiber/v1/consolidated-payment-plan/';
        this.deviceInfoUrl = '/rest-api/account/v1/getDeviceInfo?';
        // HS Scheduling Status
        this.hsSchedulingStatusUrl = '/rest-api/fiber/appointment-details/v2/schedule-eligibility';
        this.hsAvailableWirelessDiscount = '/rest-api/homeservices/v1/wirelessdiscount';
        // HS merge account
        this.mergeAccountsUrl = '/rest-api/link/account/v1/profile';
        this.accountInfoUrl = '/rest-api/profile/v1/get/accountInfo';
        // HS save cart
        this.hsSaveCartUrl = '/rest-api/account/v1/savedcart';
        // HS check activate smart wifi
        this.activateSmartWiFiUrl = '/rest-api/fiber/account/v1/activatemenu';
        // CIP: 226 - billing pdf
        this.billingPdfUrl = '/rest-api/account/bill/v1/bill-info/';
        // CIP: 255 - Cancel Future dated plan change
        this.cancelFDPCUrl = '/rest-services/web-wirelessaccount-services/v1/account/cancel-future-date-plans/';
        this.updatePendingPlanDetailsUrl = '/rest-api/account/v1/updatePendingPlanChangeDetails';
        // CIP: 294 Affinity discount for MMA
        this.affinityDiscountUrl = '/rest-api/account/v1/isEligibleForAffinityDiscount/';
        this.getPukCodeUrl = '/rest-api/account/sub/v1/puk-code?subId=';
        // WEBI:7258 - get datapass details
        this.getDataPassPurchaseUrl = '/rest-api/account/sub/v1/datapass/active';
        // CIP-383 - Get sub transaction details
        this.getSubTransactionDetailsUrl = '/rest-api/account/bill/v1/transactions';
        // Prepaid-SDR - get Renewal Date Eligibility
        this.getRenewalDateEligibilityUrl = '/rest-api/account/renewal/v1/eligibility';
        this.submitRenewalDateChangeUrl = '/rest-api/account/renewal/v1/submit';
        this.getRenewalEventHistoryUrl = '/rest-services/web-wirelessaccount-services/v1/account/renewal/events';
        // checkPending Download
        this.getCheckEsimPendingDownloadUrl = '/rest-services/web-wirelessaccount-services/v1/account/check_pending_download/';
        // getESimBypassStatus
        this.getESimBypassStatusUrl = '/rest-api/account/esim/v1/bypass';
        // addESimCard
        this.addESimCardUrl = '/rest-api/order/v1/addESimCard';
        // CIP-340 - Reset Voicemail pin
        this.resetVoicemailUrl = '/rest-api/account/v1/subscriptions/voicemail';
        // getLoggedInStatus
        this.getLoggedInStatusUrl = '/rest-api/profile/v1/wireless/loggedIn';
        // equipmentAccount Invoice Details
        this.getEquipmentAccountInvoiceDetailsUrl = '/rest-api/account/bill/v1/enterprise/invoices';
        // get SIM Change and port lock status
        this.getSimChangeAndPortLockStatusUrl = '/rest-services/web-wirelessaccount-services/v1/account/lock-status';
        this.isCPPPaying = true;
        this.emitCardDeatils = new rxjs_1.BehaviorSubject([]);
        this.cardDeatilsEmitted$ = this.emitCardDeatils.asObservable();
        this.emitBankDeatils = new rxjs_1.BehaviorSubject([]);
        this.bankDeatilsEmitted$ = this.emitBankDeatils.asObservable();
        this.emitCardDeatilsHS = new rxjs_1.BehaviorSubject([]);
        this.cardDeatilsEmittedHS$ = this.emitCardDeatilsHS.asObservable();
        this.emitBankDeatilsHS = new rxjs_1.BehaviorSubject([]);
        this.bankDeatilsEmittedHS$ = this.emitBankDeatilsHS.asObservable();
        this.emitBasketConversionStatus = new rxjs_1.BehaviorSubject([]);
        this.basketConversionEmitted$ = this.emitBasketConversionStatus.asObservable();
        this.emitGetCPPBalanceStatus = new rxjs_1.BehaviorSubject([]);
        this.cppDetailsEmitted$ = this.emitGetCPPBalanceStatus.asObservable();
        this.emitFiberAccountSubId = new rxjs_1.BehaviorSubject('');
        this.getFiberSubId$ = this.emitFiberAccountSubId.asObservable();
        this.planRefreshSubject = new rxjs_1.Subject();
        this.getPlaneRefresh$ = this.planRefreshSubject.asObservable();
    }
    updatePlanRefresh(planDetailList) {
        this.planRefreshSubject.next(planDetailList);
    }
    removeGiftCard() {
        return this.post(this.removeGiftCardUrl, '', true).pipe(operators_1.map((data) => data));
    }
    getPersonalInformation() {
        return this.get(this.accountDetailUrl).pipe(operators_1.map((data) => data));
    }
    getPersonalInformationHS() {
        return this.get(this.accountDetailUrlHS).pipe(operators_1.map((data) => data));
    }
    payByCreditCard(content) {
        return this.post(this.payByCC, content, true).pipe(operators_1.map((data) => data));
    }
    submitFinalPayment(content, eqmAccNumber, invoiceAccount) {
        let submitUrl;
        if (eqmAccNumber) {
            submitUrl = this.submitPayment + '?equipment=' + eqmAccNumber;
        }
        else if (invoiceAccount) {
            submitUrl = this.submitPayment + '?invoiceAccount=' + invoiceAccount;
        }
        else {
            submitUrl = this.submitPayment;
        }
        return this.post(submitUrl, content, true).pipe(operators_1.map((data) => data));
    }
    submitFinalPaymentGiftCard(content) {
        return this.post(this.submitPaymentGiftCard, content, true).pipe(operators_1.map((data) => data));
    }
    getFundsDetails(subscrptionId) {
        return this.get(this.fundsUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    getSavedCards(isEditCreditCardAvail, isRenewalFlow) {
        const renewalFlow = isRenewalFlow ? '/renewal' : '';
        return this.get(this.savedCard + '/' + isEditCreditCardAvail + renewalFlow).pipe(operators_1.map((data) => data));
    }
    linkFiberAcc(fomData) {
        const inputArgs = new http_1.HttpParams().set('fiberAccountId', fomData.accountNumber).set('lastFourSSN', fomData.ssnumber);
        return this.post(this.linkToFiber, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    linkFiberAccount(formData) {
        const inputArgs = new http_1.HttpParams().set('fiberAccountNumber', formData.accountNumber).set('pin', formData.mobNumber);
        return this.post(this.linkToFiberAcc, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    linkWirelessAccWithSSN(formData, mobileNumber) {
        const inputArgs = new http_1.HttpParams().set('mobileNumber', mobileNumber).set('lastFourSSN', formData.ssnumber);
        return this.post(this.linkWirelessWithSSN, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    linkWirelessAccWithMDN(formData) {
        const inputArgs = new http_1.HttpParams().set('mobileNumber', formData.mobileNumber);
        return this.post(this.linkWirelessWithMDN, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    mergeAccounts(content) {
        return this.post(this.mergeAccountsUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getAccountInfo() {
        return this.get(this.accountInfoUrl).pipe(operators_1.map((data) => data));
    }
    getFiberExpressAccDetails(value) {
        if (value != null || value !== undefined) {
            return this.get(this.fiberAccountExpressPayUrl).pipe(operators_1.map((data) => {
                this.fiberAccDetails = data;
                return data;
            }));
        }
        else {
            return this.get(this.fiberAccountUrl).pipe(operators_1.map((data) => {
                this.fiberAccDetails = data;
                return data;
            }));
        }
    }
    getFiberAccDetails() {
        return this.get(this.fiberAccountUrl).pipe(operators_1.map((data) => {
            this.fiberAccDetails = data;
            if (typeof (data) !== 'undefined' &&
                data !== null &&
                typeof (data.serviceSubscriptionDetails) !== 'undefined' &&
                data.serviceSubscriptionDetails !== null) {
                // Sort the services in such a way that any inactive services will be last in the list.
                // This is to ensure that the sidebar-linked views bound to this array will always refer to the oldest
                // active subscription (if there is an active one); else, will refer to the oldest inactive subscription.
                // Sorting is preferable in order to avoid having to make code changes to the many individual references to this service method.
                // (Changes to those individual locations would just ultimately be simulating this same logic.)
                data.serviceSubscriptionDetails.sort((d1, d2) => {
                    const d1StatusActive = (typeof (d1.status) !== 'undefined' &&
                        d1.status !== null &&
                        d1.status.toLowerCase() === 'active');
                    const d2StatusActive = (typeof (d2.status) !== 'undefined' &&
                        d2.status !== null &&
                        d2.status.toLowerCase() === 'active');
                    if (d1StatusActive && !d2StatusActive) {
                        return -1;
                    }
                    else if (d2StatusActive && !d1StatusActive) {
                        return 1;
                    }
                    else {
                        return parseInt(d1.subscriptionId, 10) - parseInt(d2.subscriptionId, 10);
                    }
                });
            }
            return data;
        }));
    }
    getFiberAccDetailsInclInactiveAccounts() {
        return this.get(this.fiberAccountInclInactiveAccountsUrl).pipe(operators_1.map((data) => {
            this.fiberAccDetails = data;
            return data;
        }));
    }
    getFiberAccDetailsLoadedSub() {
        return this.get(this.fiberAccountLoadedUrl).pipe(operators_1.map((data) => data));
    }
    getFiberAccountSubscriptions() {
        return this.get(this.fiberAccountSubscriptionsURL).pipe(operators_1.map((data) => data));
    }
    getFiberAccDetailsLite() {
        return this.get(this.fiberAccountLiteUrl).pipe(operators_1.map((data) => {
            this.fiberAccDetails = data;
            return data;
        }));
    }
    getFiberAccDetailsLiteInclInactiveAccounts() {
        return this.get(this.fiberAccountLiteInclInactiveAccountsUrl).pipe(operators_1.map((data) => {
            this.fiberAccDetails = data;
            return data;
        }));
    }
    linkCSBSAccount(fomData) {
        const inputArgs = new http_1.HttpParams().set('csbsaccountId', fomData.csbsAccountNumber).set('ssn', fomData.taxId);
        return this.post(this.linkCSBS, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getProfileState() {
        if (this.profileStateInfo) {
            return rxjs_1.of(this.profileStateInfo);
        }
        else if (this.profileStateObservable) {
            return this.profileStateObservable;
        }
        else {
            this.profileStateObservable = this.get(this.profileStateUrl).pipe(operators_1.map((data) => {
                this.profileStateObservable = null;
                this.profileStateInfo = data;
                return data;
            }), operators_1.share());
            return this.profileStateObservable;
        }
    }
    getLoginDetails() {
        return this.get(this.loginDetailsUrl).pipe(operators_1.map((data) => data));
    }
    getAccountDetails(cacheResponse, getInstallmentDetails) {
        let accUrl = this.accounturl;
        if (getInstallmentDetails) {
            accUrl = accUrl + '/getInstallmentDetails';
        }
        if (this.accountData && cacheResponse !== false) {
            if (!this.accountData.businessAccount) {
                this.emitAccountInfoLoadedSuccess('accountInfoLoadedSuccessfuly');
            }
            if (this.accountData.businessAccount && (_.isEmpty(this.accountData.subscription) || this.accountData.subscription === undefined)) {
                return this.get(accUrl).pipe(operators_1.map((data) => {
                    this.observable = null;
                    this.accountData = data;
                    this.emitAccountInfoLoadedSuccess('accountInfoLoadedSuccessfuly');
                    return data;
                }));
            }
            return rxjs_1.of(this.accountData);
        }
        else if (this.accountObservable) {
            return this.accountObservable;
        }
        else {
            this.accountObservable = this.get(accUrl).pipe(operators_1.map((data) => {
                this.accountObservable = null;
                this.accountData = data;
                // Currently showing menu loader for all accounts (Postpaid, Business, Prepaid etc.)
                //  this.emitAccountInfoLoadedSuccess('accountInfoLoadedSuccessfuly');
                //  if (this.accountData.businessAccount) {
                //    if (this.accountData.largeBusinessAccountLoadedFromWsdl) {
                //     this.emitAccountInfoLoadedSuccess('accountInfoLoadedSuccessfuly');
                //    }
                // }
                if (!this.accountData.businessAccount) {
                    this.emitAccountInfoLoadedSuccess('accountInfoLoadedSuccessfuly');
                }
                return data;
            }), operators_1.share());
            return this.accountObservable;
        }
    }
    getEmailFlagStatus() {
        return this.get(this.emailUrl).pipe(operators_1.map((data) => data));
    }
    getInstallmentDetail(subscrptionId) {
        return this.get(this.installmentDetailUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    getSessioId() {
        return this.get(this.getSessionIdUrl).pipe(operators_1.map((data) => data));
    }
    logOut(sessionId) {
        const inputArgs = new http_1.HttpParams().set('dynSessConf', sessionId);
        return this.post(this.logOutUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    manageFiberAndWirelessAcc(formData) {
        const inputArgs = new http_1.HttpParams().set('mobileNumber', formData.mobileNumber);
        return this.post(this.manageFiberAndWireless, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    linkFiberToWirelessMdn(formData) {
        const inputArgs = new http_1.HttpParams().set('mobileNumber', formData.mobileNumber);
        return this.post(this.linkFiberToWireless, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    manageWirelessAccountPin(formData) {
        const inputArgs = new http_1.HttpParams().set('pin', formData.pin);
        return this.post(this.linkToWirelessPin, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    convertNonCustomerToWireless(formData) {
        const inputArgs = new http_1.HttpParams().set('mobileNumber', formData.mobileNumber);
        return this.post(this.linkToWireless, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getCSErrorMessage() {
        if (this.csErrorMessageData) {
            return rxjs_1.of(this.csErrorMessageData);
        }
        else {
            return this.get(this.errorMsgUrl).pipe(operators_1.map((data) => {
                this.observable = null;
                this.csErrorMessageData = data;
                return data;
            }));
        }
    }
    getPrimaryuserInfo() {
        return this.get(this.primarylookUpUrl).pipe(operators_1.map((data) => data));
    }
    getDeviceListlInformation() {
        if (this.devicesData === undefined) {
            return this.get(this.deviceListUrl).pipe(operators_1.map((data) => {
                this.devicesData = data;
                return data;
            }));
        }
        else {
            return rxjs_1.of(this.devicesData);
        }
    }
    registerToBillReport() {
        return this.post(this.registerServiceUrl).pipe(operators_1.map((data) => data));
    }
    viewBillReport() {
        return this.get(this.viewBillreportUrl).pipe(operators_1.map((data) => data));
    }
    emitAccountInfoLoadedSuccess(change) {
        this.accountInfoLoadSuccessBS.next(change);
    }
    emitWSDLLoadStatus(change) {
        this.wsdlLoadStatusBS.next(change);
    }
    getAccountDetailsLite(cacheResponse) {
        if (this.accountDataLite && cacheResponse !== false) {
            return rxjs_1.of(this.accountDataLite);
        }
        else if (this.accountLiteObservable) {
            return this.accountLiteObservable;
        }
        else {
            this.accountLiteObservable = this.get(this.accountInfoLiteUrl).pipe(operators_1.map((data) => {
                this.accountLiteObservable = null;
                this.accountDataLite = data;
                return data;
            }), operators_1.share());
            return this.accountLiteObservable;
        }
    }
    getSubDetails(subscrptionId) {
        return this.get(this.subDetailsUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    // Department service calls
    getDepartmentDetails() {
        return this.get(this.departmentDetailsUrl).pipe(operators_1.map((data) => data));
    }
    addDivision(content) {
        return this.post(this.addDivisionUrl, content, true).pipe(operators_1.map((data) => data));
    }
    addDepartment(content) {
        return this.post(this.addDepartmentUrl, content, true).pipe(operators_1.map((data) => data));
    }
    // Department service call ends
    getProfileDetail(subId, cacheResponse, isAdminProfile) {
        if (this.subscriptionProfileDetails && cacheResponse === true) {
            return rxjs_1.of(this.subscriptionProfileDetails);
        }
        else {
            this.subscriptionProfileDetails = null;
            let params = new http_1.HttpParams();
            if (isAdminProfile !== undefined) {
                params = params.set('isAdminProfile', String(isAdminProfile));
            }
            const queryString = params.toString();
            const url = `${this.getProfileDetailsUrl + subId}${queryString ? '?' + queryString : ''}`;
            return this.get(url).pipe(operators_1.map((data) => {
                this.subscriptionProfileDetails = data;
                return data;
            }));
        }
    }
    createProfile(content) {
        return this.post(this.createProfileUrl, content, true).pipe(operators_1.map((data) => data));
    }
    subscribeCreateProfile(content) {
        return this.post(this.subscribeProfileUrl + '/', content, true).pipe(operators_1.map((data) => data));
    }
    subscribeUpdateProfile(content) {
        return this.put(this.subscribeProfileUrl, content, true).pipe(operators_1.map((data) => data));
    }
    updatePermission(content) {
        return this.post(this.updatePermissionUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getSavedPermission(subId, cacheResponse) {
        if (this.savedPermissionDetails && cacheResponse === true) {
            return rxjs_1.of(this.savedPermissionDetails);
        }
        else {
            this.savedPermissionDetails = null;
            return this.get(this.savedPermissionUrl + subId).pipe(operators_1.map((data) => {
                this.savedPermissionDetails = data;
                return data;
            }));
        }
    }
    resetPassword(adminProfileId) {
        const url = this.resetPasswordUrl + (adminProfileId ? '?adminProfileId=' + adminProfileId : '');
        return this.post(url, '', true).pipe(operators_1.map((data) => data));
    }
    getDepartmentList(departmentId) {
        return this.get(this.getDepartmentListUrl).pipe(operators_1.map((data) => data));
    }
    getAccountWsdlStatus() {
        if (this.accountWsdlObservable) {
            return this.accountWsdlObservable;
        }
        else {
            this.accountWsdlObservable = this.get(this.accountDetailsWsdlStatusURL).pipe(operators_1.map((data) => {
                this.accountWsdlObservable = null;
                return data;
            }), operators_1.share());
            return this.accountWsdlObservable;
        }
    }
    updateProfileDetails(formData) {
        return this.post(this.updateProfileUrl, formData, true).pipe(operators_1.map((data) => data));
    }
    refreshBBAccounts() {
        return this.get(this.accounturl).pipe(operators_1.map((data) => {
            this.accountData = data;
            return data;
        }));
    }
    getCallForwardingInfo(subId) {
        return this.get(this.callForwardingUrl + '/' + subId).pipe(operators_1.map((data) => data));
    }
    getNumberOfRingsInfo() {
        return this.get(this.ringTimeUrl).pipe(operators_1.map((data) => data));
    }
    addCallForwardingInfo(orgMDN, forwardMDN) {
        const inputArgs = new http_1.HttpParams().set('originalMobileNumber', orgMDN)
            .set('forwardedMobileNumber', forwardMDN);
        return this.post(this.callForwardingUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    removeCallForwardingInfo(orgMDN) {
        const callForwardingDetails = {
            'originalMobileNumber': orgMDN,
        };
        return this.deleteJsonApplicationData(this.callForwardingUrl, callForwardingDetails, true).pipe(operators_1.map((data) => data));
    }
    saveCallRingTimeInfo(orgMDN, ringTime) {
        const inputArgs = new http_1.HttpParams().set('originalMobileNumber', orgMDN)
            .set('ringTime', ringTime);
        return this.put(this.ringTimeUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    checkLargeBBAccount() {
        return this.get(this.accounturl).pipe(operators_1.map((data) => {
            this.accountData = data;
            return (data && data.subscription && data.subscription.length > 500);
        }));
    }
    getSavedBankDetails() {
        return this.get(this.savedBankDetailUrl).pipe(operators_1.map((data) => data));
    }
    saveNewCard(content) {
        return this.post(this.saveNewCardUrl, content, true).pipe(operators_1.map(((data) => data)));
    }
    deleteSavedCard(content) {
        return this.delete(this.deleteSavedCardCardUrl + content).pipe(operators_1.map(((data) => data)));
    }
    saveEditCardDetails(content) {
        return this.put(this.editSavedCardUrl, content, true).pipe(operators_1.map(((data) => data)));
    }
    saveBankDetails(content) {
        return this.post(this.saveBankUrl, content, true).pipe(operators_1.map(((data) => data)));
    }
    deleteSavedBankDetails() {
        return this.delete(this.deleteSavedBankUrl).pipe(operators_1.map(((data) => data)));
    }
    getPrimarySavedCards(cacheResponse) {
        if (this.cardDetails && cacheResponse === true) {
            return rxjs_1.of(this.cardDetails);
        }
        else {
            this.observable = null;
            this.cardDetails = null;
            return this.get(this.savedCCDetailsUrl).pipe(operators_1.map((data) => {
                this.emitCardDeatils.next(data);
                this.observable = null;
                this.cardDetails = data;
                return data;
            }));
        }
    }
    getPrimarySavedBankDetails(cacheResponse) {
        if (this.bankDetails && cacheResponse === true) {
            return rxjs_1.of(this.bankDetails);
        }
        else {
            this.observable = null;
            this.bankDetails = null;
            return this.get(this.savedPrimaryBankUrl).pipe(operators_1.map((data) => {
                this.emitBankDeatils.next(data);
                this.observable = null;
                this.bankDetails = data;
                return data;
            }));
        }
    }
    saveNewCardHS(content) {
        return this.post(this.saveNewCardHSUrl, content, true).pipe(operators_1.map(((data) => data)));
    }
    deleteSavedCardHS(content) {
        return this.delete(this.deleteSavedCardCardHSUrl + content).pipe(operators_1.map(((data) => data)));
    }
    saveEditCardDetailsHS(content) {
        return this.put(this.editSavedCardHSUrl, content, true).pipe(operators_1.map(((data) => data)));
    }
    saveBankDetailsHS(content) {
        return this.post(this.saveBankHSUrl, content, true).pipe(operators_1.map(((data) => data)));
    }
    deleteSavedBankDetailsHS() {
        return this.delete(this.deleteSavedBankHSUrl).pipe(operators_1.map(((data) => data)));
    }
    getPrimarySavedCardsHS(cacheResponse) {
        if (this.cardDetailsHS && cacheResponse === true) {
            return rxjs_1.of(this.cardDetailsHS);
        }
        else {
            this.observable = null;
            this.cardDetailsHS = null;
            return this.get(this.savedCCDetailsHSUrl).pipe(operators_1.map((data) => {
                this.emitCardDeatilsHS.next(data);
                this.observable = null;
                this.cardDetailsHS = data;
                return data;
            }));
        }
    }
    getPrimarySavedBankDetailsHS(cacheResponse) {
        if (this.bankDetailsHS && cacheResponse === true) {
            return rxjs_1.of(this.bankDetailsHS);
        }
        else {
            this.observable = null;
            this.bankDetailsHS = null;
            return this.get(this.savedPrimaryBankHSUrl).pipe(operators_1.map((data) => {
                this.emitBankDeatilsHS.next(data);
                this.observable = null;
                this.bankDetailsHS = data;
                return data;
            }));
        }
    }
    sendVerifyEmailLink(emailAddress) {
        const inputArgs = new http_1.HttpParams().set('emailAddress', emailAddress);
        return this.post(this.verifyEmailLink, inputArgs.toString()).pipe(operators_1.map(((data) => data)));
    }
    getBasketConversionStatus() {
        return this.get(this.convertBasketStatusURL).pipe(operators_1.map((data) => data));
    }
    checkBasketConversion(cartCountObj) {
        this.emitBasketConversionStatus.next(cartCountObj);
    }
    isApplyForWirelessBundleDiscount() {
        return this.get(this.isApplyForWirelessBundleDiscountUrl).pipe(operators_1.map((data) => data));
    }
    getPulseOffer() {
        return this.get(this.pulseOfferUrl).pipe(operators_1.map((data) => data));
    }
    getCPPBalance(isWireless, cacheResponse) {
        if ((this.cppBalanceDetails || !this.isCPPPaying) && cacheResponse) {
            return rxjs_1.of(this.cppBalanceDetails);
        }
        else {
            this.observable = null;
            this.cppBalanceDetails = null;
            return this.get(this.cppBalanceUrl + isWireless).pipe(operators_1.map((data) => {
                if (data) {
                    this.emitGetCPPBalanceStatus.next(data);
                    this.observable = null;
                    this.cppBalanceDetails = data;
                    this.isCPPPaying = true;
                }
                else {
                    this.isCPPPaying = false;
                }
                return data;
            }));
        }
    }
    saveHSCPPDetails(content) {
        return this.post(this.saveHSCPPDetailsUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getHSCPPDetails() {
        return this.get(this.saveHSCPPDetailsUrl).pipe(operators_1.map((data) => data));
    }
    getDeviceInfo(type, serailNo) {
        const inputArgs = new http_1.HttpParams().set('searchBy', type).set('searchFor', serailNo);
        return this.get(this.deviceInfoUrl + inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getSchedulingStatus() {
        return this.get(this.hsSchedulingStatusUrl).pipe(operators_1.map((data) => data));
    }
    checkIfWirelessDiscountAvailable() {
        return this.get(this.hsAvailableWirelessDiscount).pipe(operators_1.map((data) => data));
    }
    setFiberAccountSubId(subId) {
        this.emitFiberAccountSubId.next(subId);
    }
    verifyCustomer(ssnOrPin) {
        const inputArgs = new http_1.HttpParams().set('ssnOrPin', ssnOrPin);
        return this.post(this.paymentAuthStatusUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getPaymentAuthStatus() {
        return this.get(this.paymentAuthStatusUrl).pipe(operators_1.map((data) => data));
    }
    getAllMMAProfiles() {
        return this.get(this.allMMAProfilesUrl).pipe(operators_1.map((data) => data));
    }
    getHsSaveCartData() {
        return this.get(this.hsSaveCartUrl).pipe(operators_1.map((data) => data));
    }
    isSmartWiFiActivationAllowed() {
        return this.get(this.activateSmartWiFiUrl).pipe(operators_1.map((data) => data));
    }
    // CIP:226 - get bill pdf
    getbillingPdf(endDate) {
        return this.get(this.billingPdfUrl + endDate).pipe(operators_1.map((data) => data));
    }
    // CIP: 255 - Cancel Future Dated Plan change
    cancelFutureDatedPLan(subId, oauthToken) {
        let headers = new http_1.HttpHeaders();
        headers = headers.set('Client', 'WEB');
        if (oauthToken) {
            headers = headers.append('CS-SESSION-ID', oauthToken.sessionId);
            headers = headers.append('Authorization', ('bearer ' + oauthToken.token));
        }
        return this.get(this.cancelFDPCUrl + subId, headers).pipe(operators_1.map((data) => data));
    }
    noOfDaysInFuture(serviceDate) {
        if (serviceDate === null) {
            return null;
        }
        const date = new Date();
        const userOffset = date.getTimezoneOffset() * 60 * 1000;
        const centralOffset = 6 * 60 * 60 * 1000; // using GMT -6 for server time
        const todaysDate = date.getTime();
        const oneDay = 1000 * 60 * 60 * 24;
        const serviceActivationDate = Date.parse(serviceDate) + centralOffset + userOffset;
        if (serviceActivationDate > todaysDate) {
            const val = Math.floor((serviceActivationDate - todaysDate) / oneDay);
            if (val === 0) {
                const desc = 'less than a';
                return desc;
            }
            else {
                return val;
            }
        }
        else {
            return null;
        }
    }
    hasPendingServiceDates(serviceSubscriptionDetails) {
        const serviceActivationDates = serviceSubscriptionDetails.serviceFeatureActivationDate;
        const serviceEndDates = serviceSubscriptionDetails.serviceFeatureEndDate;
        for (const key in serviceActivationDates) {
            if (this.noOfDaysInFuture(serviceActivationDates[key])) {
                const noOfDays = this.noOfDaysInFuture(serviceActivationDates[key]);
                const feature = serviceSubscriptionDetails.serviceFeatureDisplayName[key];
                const description = 'activated';
                return {
                    noOfDays,
                    feature,
                    description
                };
            }
        }
        for (const key in serviceEndDates) {
            if (this.noOfDaysInFuture(serviceEndDates[key])) {
                const noOfDays = this.noOfDaysInFuture(serviceEndDates[key]);
                const feature = serviceSubscriptionDetails.serviceFeatureDisplayName[key];
                const description = 'removed';
                return {
                    noOfDays,
                    feature,
                    description
                };
            }
        }
        return null;
    }
    getAffinityDiscountEligibility() {
        return this.get(this.affinityDiscountUrl).pipe(operators_1.map((data) => data));
    }
    updatePendingPlanChangeDetails() {
        return this.get(this.updatePendingPlanDetailsUrl).pipe(operators_1.map((data) => data));
    }
    getPukCode(subId) {
        return this.get(this.getPukCodeUrl + subId).pipe(operators_1.map((data) => data));
    }
    /**
     * WEBI:7258
    */
    getDataPassPurchaseDetails() {
        return this.get(this.getDataPassPurchaseUrl).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP-383 - get transaction details
     */
    getSubTransactionDetails() {
        return this.get(this.getSubTransactionDetailsUrl).pipe(operators_1.map((data) => data));
    }
    // Prepaid-SDR - get Renewal Date Eligibility
    getRenewalDateEligibility(cacheResponse) {
        if (this.renewalDateEligibilityResponse && cacheResponse) {
            return rxjs_1.of(this.renewalDateEligibilityResponse);
        }
        else if (this.renewalEligibilityObservable && cacheResponse) {
            return this.renewalEligibilityObservable;
        }
        else {
            this.renewalEligibilityObservable = this.get(this.getRenewalDateEligibilityUrl).pipe(operators_1.map((data) => {
                this.renewalEligibilityObservable = null;
                this.renewalDateEligibilityResponse = data;
                return data;
            }), operators_1.share());
            return this.renewalEligibilityObservable;
        }
    }
    submitNoPaymentRenewalChange(content) {
        return this.post(this.submitRenewalDateChangeUrl, content, true).pipe(operators_1.map((data) => data));
    }
    getRenewalEventHistory() {
        return this.get(this.getRenewalEventHistoryUrl).pipe(operators_1.map((data) => data));
    }
    /**
    * pending Download
    */
    getCheckEsimPendingDownload(subId) {
        return this.get(this.getCheckEsimPendingDownloadUrl + subId).pipe(operators_1.map((data) => data));
    }
    /**
     * getESimBypassStatus
     */
    getESimBypassStatus() {
        return this.get(this.getESimBypassStatusUrl).pipe(operators_1.map((data) => data));
    }
    /**
     * addESimCard
     */
    addESimCard(subId, activationType) {
        const inputArgs = new http_1.HttpParams().set('activationType', activationType)
            .set('subId', subId);
        return this.post(this.addESimCardUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    updateAccountDetails(formData) {
        const inputArgs = new http_1.HttpParams().set('subscriptionId', formData.subscriptionId).set('firstName', formData.firstName)
            .set('lastName', formData.lastName);
        return this.put(this.updateAccountUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    resetVoiceMailPin(originalMobileNumber) {
        const inputArgs = new http_1.HttpParams().set('originalMobileNumber', originalMobileNumber);
        return this.put(this.resetVoicemailUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    /**
     * @returns Observable of type LoggedInStatus - returns an object of logged in status of the user
     */
    getLoggedInStatus() {
        return this.get(this.getLoggedInStatusUrl).pipe(operators_1.map((res) => res));
    }
    getEquipmentAccountInvoiceDetails() {
        return this.get(this.getEquipmentAccountInvoiceDetailsUrl).pipe(operators_1.map((res) => res));
    }
    getSimChangeAndPortOutLockStatus() {
        return this.get(this.getSimChangeAndPortLockStatusUrl).pipe(operators_1.map((data) => data));
    }
    submitSimChangeAndPortOutLockStatus(content) {
        return this.post(this.getSimChangeAndPortLockStatusUrl, content, true).pipe(operators_1.map((data) => data));
    }
}
exports.AccountService = AccountService;
AccountService.ɵprov = i0.ɵɵdefineInjectable({ factory: function AccountService_Factory() { return new AccountService(i0.ɵɵinject(i1.HttpClient)); }, token: AccountService, providedIn: "root" });
//# sourceMappingURL=account.service.js.map